var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{attrs:{"size":_vm.size || 'lg',"text":_vm.initials,"src":_vm.gravatar,"variant":"secondary","onerror":"this.style.display = \"none\""}})}
var staticRenderFns = []

export { render, staticRenderFns }